import React from "react";

import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import HeadSearch from "../headSearch/HeadSearch";
import LeftMenu from "../leftSideComponent/LeftSide";
import AccountLedgerBillHistory from "./AccountLedgerBillHistory";
import AccoubtLedgerFilter from "./AccoubtLedgerFilter";
import AccountLedgerType from "./AccountLedgerType";
import './pager.css';


class AccountLedger extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone
		}
    }

	componentDidMount(){
	}
	componentWillUnmount(){
    }


    render(){
    console.log('Inside render');
    return(
		<div>
			<div class="main">
			<LeftMenu/>
			<div class="right-side">
			<div class="container-fluid">
			<Header/>
			<div class="row">
			<div class="card">
			<div class="dashhead">
			<h3>Account Ledger</h3>
			{/* <AccoubtLedgerFilter/> */}
			<HeadSearch/>
			</div>
			<AccountLedgerType/>
			<AccountLedgerBillHistory/>
			</div>
			</div>
				</div>
			</div>

			</div>
			<div class="footer-txt">Copyright &copy; 2021 All rights reserved. <br/>Powered by FinXpay Solutions Pvt. Ltd.</div>
		</div>

		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(AccountLedger);
